import AddNewButton from '@/components/buttons/training-module/AddNewButton';
import AddNewGroupButton from '@/components/buttons/training-module/AddNewGroupButton';
import SearchInput from '@/components/input/SearchInput';
import { SEARCH_QUERY } from '@/constant/queryURLKey';
import { useRouter } from 'next/router';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
interface ITrainingSectionHeader {
  children: React.ReactElement;
}
interface ITSHSearchInput {
  destinationAfterSearch: string;
  className?: string;
  searchPlaceholder?: string;
}
interface ITHSAddNewButton {
  group?: boolean;
  addNewFolder?: boolean;
  uploadNewFile?: boolean;
  queryKey?: string | string[];
  idSaveOn?: string;
}

const TrainingSectionHeaderContext = createContext<{
  searchValue: string;
  setSearchValue: Function;
}>({
  searchValue: '',
  setSearchValue: () => {},
});

const TrainingSectionHeader = ({ children }: ITrainingSectionHeader) => {
  const [searchValue, setSearchValue] = useState('');

  const router = useRouter();

  useEffect(() => {
    router.isReady && setSearchValue(router.query[SEARCH_QUERY] as string);
  }, [router.isReady, router.query]);

  return (
    <>
      <TrainingSectionHeaderContext.Provider
        value={{ searchValue, setSearchValue }}
      >
        {children}
      </TrainingSectionHeaderContext.Provider>
    </>
  );
};

TrainingSectionHeader.SearchInput = function TSHSearchInput({
  destinationAfterSearch,
  className,
  searchPlaceholder,
}: ITSHSearchInput) {
  const { searchValue, setSearchValue } = useContext(
    TrainingSectionHeaderContext
  );
  const router = useRouter();

  return (
    <SearchInput
      className={className}
      icon={<AiOutlineSearch />}
      placeholder={searchPlaceholder || 'Tìm kiếm tệp theo tên'}
      value={searchValue}
      setValue={setSearchValue}
      callBackAfterSubmit={() =>
        destinationAfterSearch &&
        router.replace(
          `${destinationAfterSearch}?${SEARCH_QUERY}=${searchValue}`
        )
      }
      redirectAfterClear={destinationAfterSearch}
    />
  );
};

TrainingSectionHeader.AddNewButton = function THSAddNewButton({
  group,
  addNewFolder,
  uploadNewFile,
  queryKey,
  idSaveOn,
}: ITHSAddNewButton) {
  return !group ? (
    <AddNewButton
      addNewFolder={addNewFolder}
      uploadNewFile={uploadNewFile}
      queryKey={queryKey}
      idSaveOn={idSaveOn}
    />
  ) : (
    <AddNewGroupButton queryKey={queryKey} />
  );
};

TrainingSectionHeader.ReturnButton = function THSReturnButton({
  children,
}: {
  children: React.ReactElement;
}) {
  return children;
};

export default TrainingSectionHeader;
